// Image card for Programs overview section for (Fertility)
import React from 'react';

const DetailImageCards = ({ data }) => {
  if (!data) {
    console.warn('DetailImageCards: data prop is undefined');
    return null;
  }

  const { id, heading, subheading, cards } = data;

  return (
    <section id={id} className="w-full bg-white py-10 md:py-14">
      <div className="container mx-auto px-4 md:px-8">

        {/* ── Centered heading ── */}
        <h2
          className="text-center font-bold mb-2"
          style={{
            color: 'var(--primary-color)',
            fontSize: 'clamp(1.2rem, 2.5vw, 1.8rem)',
          }}
        >
          {heading}
        </h2>

        {/* ── Centered subheading ── */}
        {subheading && (
          <p
            className="text-center text-sm md:text-base mb-8"
            style={{ color: 'var(--text-light)' }}
          >
            {subheading}
          </p>
        )}

        {/* ── Cards row — horizontal scroll on mobile ── */}
        <div
          className="flex gap-3 md:gap-4 overflow-x-auto pb-2 md:pb-0 md:grid"
          style={{
            gridTemplateColumns: `repeat(${cards.length}, minmax(0, 1fr))`,
            scrollbarWidth: 'none',
          }}
        >
          {cards.map((card) => (
            <ImageCard key={card.id} card={card} />
          ))}
        </div>

      </div>
    </section>
  );
};

/* ── Individual image card ── */
const ImageCard = ({ card }) => (
  <div
    className="relative flex-shrink-0 rounded-2xl overflow-hidden"
    style={{
      minWidth: '160px',
      aspectRatio: '3 / 2',
    }}
  >
    {/* Background image */}
    <img
      src={card.image}
      alt={card.label}
      className="absolute inset-0 w-full h-full object-cover object-center"
      draggable={false}
    />

    {/* Dark overlay */}
    <div
      className="absolute inset-0"
      style={{ backgroundColor: 'rgba(0, 36, 107, 0.45)' }}
    />

    {/* Centered white label */}
    <div className="absolute inset-0 flex items-center justify-center p-3">
      <p
        className="text-white text-center font-medium leading-snug"
        style={{ fontSize: 'clamp(0.7rem, 1.5vw, 0.9rem)' }}
      >
        {card.label}
      </p>
    </div>
  </div>
);

export default DetailImageCards;